export default function isBetween(value, lower, upper) {
  return value > lower && value < upper;
}
